import {Component, HostBinding} from '@angular/core';
import {BrowserTabService} from '../../browser-tab/browser-tab.service';
import {AuthorizationService} from '../../authorization/authorization.service';
import {UserBalanceService} from '../user-balance.service';
import {OAuthService} from 'angular-oauth2-oidc';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-mobile-top-menu',
  templateUrl: './mobile-top-menu.component.html',
})
export class MobileTopMenuComponent {
  @HostBinding('class.info-right-box') mobileTopMenuComponent = true;
  menuIsOpen = false;
  documentation = environment.documentation;

  constructor(
    public authorizationService: AuthorizationService,
    public browserTabService: BrowserTabService,
    public userBalance: UserBalanceService,
    public oauthService: OAuthService,
  ) {
  }
}
